import styles from "./css/Image.module.css"

export default function Image({ src, alt, width, height, className }) {
    return (
        <div className={`${styles.imageContainer} ${className}`}>
            <img src={src} alt={alt} width={width} height={height} />
        </div>
    )
}